// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"QZ-z","sponsoredTooltipWrapper":"RZ-z","sponsoredTooltip":"SZ-z","newCard":"TZ-z"};